import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { revertCatalogStores } from 'shared/ui/store/resetStoresAction';

import { moveToInventoryItemService } from '../services/moveToInventoryItemService';
import { MoveToInventoryItemSchema } from '../types/MoveToInventoryItemSchema';

const initialState: MoveToInventoryItemSchema = {
    showDialog: false,
    isLoading: false,
    isSingle: false,
};

export const MoveToInventoryItemSlice = createSlice({
    name: 'MoveToInventoryItem',
    initialState,
    reducers: {
        setShowDialog: (state, action: PayloadAction<boolean>) => {
            state.showDialog = action.payload;
        },
        setIsSingle: (state, action: PayloadAction<boolean>) => {
            state.isSingle = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(revertCatalogStores, () => initialState)
            .addCase(moveToInventoryItemService.pending, (state) => {
                state.error = undefined;
                state.isLoading = true;
            })
            .addCase(moveToInventoryItemService.fulfilled, (state, action) => {
                state.isLoading = false;
                state.showDialog = false;
            })
            .addCase(moveToInventoryItemService.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export const { actions: moveToInventoryItemActions } = MoveToInventoryItemSlice;
export const { reducer: moveToInventoryItemReducer } = MoveToInventoryItemSlice;
